export default function absCeil (number) {
    if (number < 0) {
        return Math.floor(number);
    } else {
        return Math.ceil(number);
    }
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/moment/src/lib/utils/abs-ceil.js
// module id = 252
// module chunks = 0